import { COLLECTIONS } from "constants/action-types";

import { List, Map } from "immutable";

interface IChangeCurrentView {
    name?: string;
    data?: List<Map<string, any>>;
}
export const changeCurrentView = ({ name, data }: IChangeCurrentView) => ({
    payload: {
        currentViewName: name,
        currentView: data,
    },
    type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.CURRENT_VIEW.CHANGE,
});
